import AuthRoles from "@core/auth/AuthRoles";
import CreateAdvert from "../views/CreateAdvert";
import CreateSellerAdvert from "../views/CreateSellerAdvert";

const AdvertPrivateRoute = {
  auth: AuthRoles.user,
  routes: [
    {
      path: "/ilanOlustur",
      component: CreateAdvert,
    },
    {
      path: "/satici/ilan-olustur",
      component: CreateSellerAdvert,
    },
  ],
};

export default AdvertPrivateRoute;
